export const ROUTE_POINTS_RESET_STATE = 'ROUTE_POINTS_RESET_STATE';
export const ROUTE_POINTS_CURRENT_ITEM = 'ROUTE_POINTS_CURRENT_ITEM';

export const ROUTE_POINTS_REQUEST_LOADING = 'ROUTE_POINTS_REQUEST_LOADING';
export const ROUTE_POINTS_REQUEST_SUCCESS = 'ROUTE_POINTS_REQUEST_SUCCESS';
export const ROUTE_POINTS_REQUEST_FAILED = 'ROUTE_POINTS_REQUEST_FAILED';

export const ROUTE_POINTS_CURRENT_ACTION = 'ROUTE_POINTS_CURRENT_ACTION';
export const ROUTE_POINTS_RESET_ACTION = 'ROUTE_POINTS_RESET_ACTION';